// extracted by mini-css-extract-plugin
export default {"home":"AddSubject_home__ektEN","hr":"AddSubject_hr__IMfLg","main":"AddSubject_main__OoGS6"};